import { render, staticRenderFns } from "./SingleFileInput.vue?vue&type=template&id=4a6b21fa&scoped=true"
import script from "./SingleFileInput.vue?vue&type=script&lang=js"
export * from "./SingleFileInput.vue?vue&type=script&lang=js"
import style0 from "./SingleFileInput.vue?vue&type=style&index=0&id=4a6b21fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6b21fa",
  null
  
)

export default component.exports